<template>
  <div>
    <v-row class="pa-1">
      <v-col class="d-flex pa-0">
        <!-- Search -->
        <strong class="mt-2 mr-2">{{ $t("PROBLEM_TYPE") }}</strong>
        <v-select
          dense
          :items="probleType"
          v-model="keyword"
          item-value="key"
          hide-details
          outlined
          class="text-field-search mr-10"
        />
        <v-btn color="primary" class="font-weight-black" @click="search">{{
          $t("SEARCH")
        }}</v-btn>
        <v-spacer />
        <!-- Sort List General -->
        <v-btn :to="paramsRearecte('Sort List')" class="mr-4" color="primary"
          >並び替え</v-btn
        >
        <!-- Select create General -->
        <v-btn
          :to="paramsRearecte('Select Create')"
          class="mr-4"
          color="primary"
          :disabled="validateCreateButton"
          v-if="subKey !== 'section'"
          >既存の問題から選択</v-btn
        >
        <!-- Create General -->
        <v-btn
          :to="paramsRearecte('Create')"
          v-text="$t('CREATE_NEW')"
          :disabled="validateCreateButton"
          color="primary"
        />
      </v-col>
    </v-row>

    <!-- List Question -->
    <v-row>
      <v-layout class="mx-1 mt-5" child-flex>
        <v-data-table
          :headers="headers"
          fixed-header
          :items="listQuestion"
          :items-per-page="50"
          :loading="loadingListQuestion"
          loading-text="読み込み中。。。待ってください。"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.type_value="{ item }">{{
            probleType.find((e) => e.key == item.type_value)
              ? probleType.find((e) => e.key == item.type_value).text
              : ""
          }}</template>
          <template v-slot:item.lead_sentence="{ item }">
            <span class="pre-wrap">{{ item.lead_sentence }}</span>
          </template>
          <template v-slot:item.name="{ item: { type_value, name }, item }">
            <!-- type_value == 'Choices' -->
            <template
              v-if="type_value == 'Choices' && typeof name[0] != 'string'"
            >
              <v-row
                class="mx-0"
                v-for="(rowName, idx) in name"
                :key="`preview-${idx}`"
                :justify="
                  name.length == 1 && (!rowName[0] || !rowName[2])
                    ? 'center'
                    : null
                "
              >
                <span
                  class="text--h4 pre-wrap"
                  v-if="rowName[0]"
                  v-html="`${replaceText(rowName[0])}`"
                />
                <span
                  class="text--h4 font-weight-bold pre-wrap"
                  v-if="rowName[1] || rowName[1] == ''"
                  v-html="`（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）`"
                />
                <span
                  class="text--h4 pre-wrap"
                  v-if="rowName[1]"
                  v-html="`${replaceText(rowName[1])}`"
                ></span>
              </v-row>
            </template>
            <!-- type_value == 'Sort' -->
            <template v-if="type_value == 'Sort' && typeof name[0] != 'string'">
              <v-row
                class="mx-0"
                v-for="(rowName, idx) in name"
                :key="`preview-${idx}`"
                :justify="
                  name.length == 1 && (!rowName[0] || !rowName[2])
                    ? 'center'
                    : null
                "
              >
                <span class="pre-wrap text--h4">
                  <v-row class="d-flex mt-1" no-gutters>
                    {{ replaceText(rowName[0]) }}
                    <template v-if="rowName[1] || rowName[1] == ''">
                      <strong>1</strong>

                      <strong class="mx-1">2</strong>

                      <strong>3</strong>

                      <strong class="mx-1">4</strong>
                    </template>

                    <template v-if="rowName[1] || rowName[1] == ''">
                      {{ replaceText(rowName[1]) }}
                    </template>
                  </v-row>
                </span>
              </v-row>
            </template>
            <span
              v-html="nameConvert(item)"
              v-else-if="
                typeof name[0] == 'string' &&
                (type_value == 'Choices' || type_value == 'Sort')
              "
            />
            <span
              v-html="nameConvert(item)"
              v-else-if="type_value != 'Choices' && type_value != 'Sort'"
            />
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- Edit Question -->
            <v-icon
              size="22"
              @click="handleEditORViewDetailItem(item, 'Update')"
              >fas fa-pencil-alt</v-icon
            >

            <!-- View item -->
            <span class="mx-5">
              <v-icon
                size="22"
                @click="handleEditORViewDetailItem(item, 'Detail')"
                >fas fa-eye</v-icon
              >
            </span>

            <!-- Delete item for Question -->
            <DeleteItemGeneral
              :item="item"
              @resetList="handleGetListQuestion"
            />
          </template>
          <template v-slot:no-data>データがありません。</template>
        </v-data-table>
      </v-layout>
    </v-row>
  </div>
</template>

<script>
import { getListQuestion } from "@/api/Question.api";
import DeleteItemGeneral from "@/views/listGeneral/DeleteItemGeneral";
export default {
  store: ["formGeneral"],
  components: {
    DeleteItemGeneral,
  },
  data() {
    return {
      keyword: "",
      listQuestion: [],
      loadingListQuestion: false,
      defaultListQuestion: [],
      probleType: [
        { text: "全て", type: "all", key: "" },
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
      ],
      pagination: {
        page: 1,
        pageCount: 0,
        maxResultCount: 5,
      },
      headers: [
        {
          text: "No.",
          align: "start",
          value: "no",
        },
        { text: this.$i18n.t("PROBLEM_TYPE"), value: "type_value" },
        { text: this.$i18n.t("DIRECTIVE"), value: "lead_sentence" },
        { text: this.$i18n.t("QUESTION"), value: "name", width: "30%" },
        {
          text: this.$i18n.t("ACTION"),
          value: "actions",
          align: "center",
          width: "150px",
        },
      ],
      subKey: "",
    };
  },
  async created() {
    this.setSubKey();
    await this.handleGetListQuestion();
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.name !== "List General OF Section") {
      this.probleType.push(
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" }
      );
    }
  },
  watch: {
    $route: async function () {
      this.setSubKey();
      // console.log("this.subKey: ", this.subKey);
      if (this.$route.name !== "List General OF Section") {
        this.probleType.push(
          { text: "読解：4択", type: "read", key: "Comprehension" },
          { text: "読解：複数選択", type: "read", key: "MultiRead" }
        );
      }
      await this.handleGetListQuestion();
    },
  },
  computed: {
    validateCreateButton() {
      const { subKey, defaultListQuestion } = this;
      if (subKey == "season" && defaultListQuestion.length >= 50) {
        return true;
      } else if (subKey == "chapter" && defaultListQuestion.length >= 30) {
        return true;
      } else if (subKey == "section" && defaultListQuestion.length >= 10) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async handleGetListQuestion() {
      const { subKey } = this;
      console.log("this.$route.params: ", this.$route.params);
      let params = {
        id: this.$route.params[subKey],
      };
      this.loadingListQuestion = true;
      let response = await getListQuestion(params).catch(this.$toast.error);
      if (!response) return (this.loadingListQuestion = false);
      this.listQuestion = response.result;
      this.defaultListQuestion = response.result;
      this.pagination.pageCount = response.totalCount;
      this.loadingListQuestion = false;
    },
    setSubKey() {
      if (this.$route.name == "List General OF Season") {
        this.subKey = "season";
      } else if (this.$route.name == "List General OF Chapter") {
        this.subKey = "chapter";
      } else if (this.$route.name == "List General OF Section") {
        this.subKey = "section";
      }
    },
    async search() {
      await this.handleGetListQuestion();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.defaultListQuestion.filter((item) => {
        console.log(item.type_value.toLowerCase().search(keywordSearch) > -1);
      });
      console.log("keywordSearch: ", keywordSearch);
      this.listQuestion = this.defaultListQuestion.filter((item) => {
        return item.type_value.toLowerCase().search(keywordSearch) > -1;
      });
      this.pagination.pageCount = this.listQuestion.length;
    },
    handleEditORViewDetailItem(item, key) {
      let rearecte = this.paramsRearecte(key);
      rearecte.params.id = item.Id;
      if (key !== "Create") {
        console.log("no-------", this.$route.query)
        rearecte.query = { ...this.$route.query,  no: item.no };
      } else {
        let query = { ...this.$route.query, ...rearecte };
        rearecte.query = query;
      }
      this.$router.push(rearecte);
    },
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    nameConvert(item) {
      const { type_value } = item;
      if (type_value == "Choices") {
        return `${this.replaceText(
          item.name[0]
        )}（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;） ${this.replaceText(
          item.name[1]
        )}`;
      }
      if (type_value == "Sort") {
        return `${this.replaceText(
          item.name[0]
        )} <strong>1</strong> <strong>2</strong> <strong>3</strong> <strong>4</strong> ${this.replaceText(
          item.name[1]
        )}`;
      }
      if (type_value == "Conjugation") {
        let unline = "";
        item.list_answer.answer[0].forEach(() => {
          unline += " __ ";
        });
        return `${this.replaceText(
          item.list_answer.sentence_answer[0]
        )} ${unline} ${this.replaceText(item.list_answer.sentence_answer[1])}`;
      }
      if (type_value == "Kanji") {
        return `${this.replaceText(item.name[0][0])} <u>${this.replaceText(
          item.name[0][1]
        )}</u> ${this.replaceText(item.name[0][2])}`;
      }
      if (item.name[0] && item.name[0][0]) {
        return this.replaceText(item.name[0][0]);
      } else if (item.name[0]) {
        return item.name[0][0];
      } else {
        return "";
      }
    },
    paramsRearecte(key) {
      var paramsRearecte = "";
      const { query } = this.$route;
      let queryCustom = { ...query };
      console.log("queryCustom: ",queryCustom)
      if (key == "Sort List") {
        queryCustom.questionNo += "の並び替え";
      }
      if (key == "Select Create") {
        queryCustom.questionNo += "登録";
      }
      if (this.$route.name == "List General OF Season") {
        paramsRearecte = {
          name: `${key} General OF Season`,
          params: { season: this.$route.params.season },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : queryCustom,
        };
      } else if (this.$route.name == "List General OF Chapter") {
        paramsRearecte = {
          name: `${key} General OF Chapter`,
          params: { chapter: this.$route.params.chapter },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : queryCustom,
        };
      } else if (this.$route.name == "List General OF Section") {
        paramsRearecte = {
          name: `${key} General OF Section`,
          params: { section: this.$route.params.section },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : queryCustom,
        };
      }
      return paramsRearecte;
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      name: [["", ""]],
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>